import { sort } from "ramda";
import { TravelStyleDetail } from "@/types/dto/pdp/pdp-header-about";

const stylesOrder = ["Classic", "Explorations", "Spotlights", "Cruising", "Faith"] as const;

const getPrimaryTravelStyle = (
  locale: string,
  thisTourTravelStyle: TravelStyleDetail["name"][]
): string | null => {
  if (locale.toLowerCase() === "en-au" && thisTourTravelStyle.includes("Explorations")) {
    return "Explorations";
  }
  if (thisTourTravelStyle.includes("Classic")) {
    return "Classic";
  }
  return null;
};

const sortTravelStyles = (
  thisTourTravelStyle: TravelStyleDetail["name"][],
  travelStyles: TravelStyleDetail[],
  locale: string
) => {
  // set primary Travel Style
  const primary = getPrimaryTravelStyle(locale, thisTourTravelStyle);

  // reset order with primary at start
  const order: string[] = primary
    ? [primary, ...stylesOrder.filter((s) => s !== primary)]
    : [...stylesOrder];

  // make set with all styles in tour
  const inTourSet = new Set(thisTourTravelStyle);

  const byInTourThenOrder = (a: TravelStyleDetail, b: TravelStyleDetail) => {
    const aIn = inTourSet.has(a.name) ? 0 : 1;
    const bIn = inTourSet.has(b.name) ? 0 : 1;

    // if one is in the set and other is not, sort those
    if (aIn !== bIn) return aIn - bIn;

    // if both are in set or both are not, sort based on reset order
    return order.indexOf(a.name) - order.indexOf(b.name);
  };

  return sort(byInTourThenOrder, [...travelStyles]);
};

export default sortTravelStyles;
